// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
// Режим вида ячеек «Changes since previous run» (Зміни з минулого розрахунку) — бэк T6 (prev_val).
// Спутник ячейки-даты (§1.2): prev_val = { мера: значение в предыдущем расчёте }; нет ключа — в прошлом значения не было (прошлое = 0).
// Круг по max(текущее, прошлое): layersOf → sizeValue (cellRing_build opts.sizeValue), value = текущее — шкала группы считает max по значениям ячеек,
// и размер по прошлому значению не даёт ложного кольца over-100. Тёмный слой ('solid') — текущее, светлый ('light-2') — часть, которой уже нет
// (прошлое > текущего); выросло — сигнал { kind: 'grown' } (зелёное кольцо). Подсказка «було → стало (Δ, %)» (tipOf → { caption, note }).
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9): реализация (была заглушка T1). Тесты — tests/unit/cellViewDeltaPrevRun.test.mjs
import { t as tI18n } from '@/i18n'
import { CELL_RING_COLORS } from '@/utils/cellRing'

export const DELTA_PREV_RUN_VIEW = 'delta_prev_run'
export const DELTA_PREV_RUN_COLOR = '#546e7a'   // тёмный слой (текущее); светлый — тот же цвет тоном light-2
export const DELTA_PREV_RUN_GONE_TONE = 'light-2'

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)
const isNum = (v) => v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))

// сравнение ячейки: cur — значение ячейки, prevVal — спутник prev_val, measure → { cur, prev, had, delta, pct } | null (нет спутника / мера не задана)
export function deltaPrevRun_compare(cur, prevVal, measure) {
    const ms = str(measure)
    if (!isObj(prevVal) || !ms) return null
    const had = Object.prototype.hasOwnProperty.call(prevVal, ms) && isNum(prevVal[ms])
    const c = isNum(cur) ? Number(cur) : 0
    const p = had ? Number(prevVal[ms]) : 0
    const delta = c - p
    const pct = p !== 0 ? delta / Math.abs(p) : null
    return { cur: c, prev: p, had, delta, pct }
}

// слои круга: текущее (тёмное) + исчезнувшая часть (светлая, если прошлое > текущего); сигналы — grown, если выросло
export function deltaPrevRun_layers(cmp, t = tI18n) {
    if (!cmp) return null
    const tt = typeof t === 'function' ? t : (x) => x
    const cur = Math.abs(cmp.cur), prev = Math.abs(cmp.prev)
    const layers = [{ key: 'current', title: tt('Current'), value: cur, color: DELTA_PREV_RUN_COLOR, tone: 'solid' }]
    if (prev > cur) layers.push({ key: 'gone', title: tt('Only in the previous run'), value: prev - cur, color: DELTA_PREV_RUN_COLOR, tone: DELTA_PREV_RUN_GONE_TONE })
    const signals = cur > prev ? [{ kind: 'grown', color: CELL_RING_COLORS.grown }] : []
    return { layers, signals, sizeValue: Math.max(cur, prev), value: cmp.cur }
}

const pctText = (p) => {
    if (p === null || !Number.isFinite(p)) return ''
    const v = Math.round(p * 1000) / 10
    return `${v > 0 ? '+' : ''}${v}%`
}

export default {
    key: DELTA_PREV_RUN_VIEW,
    title: 'Changes since previous run',
    satellites: ['prev_val'],
    needsData: true,
    // ctx: { t, date, measure, cell (= dataItem[date]), value }
    layersOf(dataItem, binding, ctx = {}) {
        const cell = ctx.cell
        if (!isObj(cell)) return null
        const cmp = deltaPrevRun_compare(ctx.value, cell.prev_val, ctx.measure)
        const res = deltaPrevRun_layers(cmp, ctx.t || tI18n)
        if (!res) return null
        return { ...res, cmp, satellite: 'prev_val' }
    },
    tipOf(res, ctx = {}) {
        const t = ctx.t || tI18n
        const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => String(v)
        const cmp = res && res.cmp
        if (!cmp) return { caption: t('Compared with the previous run') }
        const note = []
        if (!cmp.had) note.push(t('Not in the previous run'))
        const d = cmp.delta
        const pct = pctText(cmp.pct)
        note.push(`${t('Was {was} → now {now}', { was: fmt(cmp.prev), now: fmt(cmp.cur) })} (Δ ${d > 0 ? '+' : (d < 0 ? '−' : '')}${fmt(Math.abs(d))}${pct ? ', ' + pct : ''})`)
        return { caption: t('Compared with the previous run'), note }
    },
    cacheKey(dataItem, ctx = {}) {
        const c = ctx.cell
        const pv = isObj(c) && isObj(c.prev_val) ? c.prev_val[str(ctx.measure)] : undefined
        return isNum(pv) ? String(pv) : '-'
    },
}
